<div id="incubation-centre" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Incubation Centre</h2>
    <p class="inner-lead mt-3">
      The Incubation Centre at Shah Satnam Ji Girls' College is dedicated to nurturing innovation, creativity, and entrepreneurship among our students. We provide a platform for young minds to transform their ideas into viable business ventures.
    </p>

    <div class="row mt-4 g-4">
      <div class="col-md-6">
        <h4 class="section-subtitle">Core Objectives</h4>
        <ul class="inner-lead">
          <li>To foster a culture of innovation and self-reliance.</li>
          <li>To provide mentorship and professional guidance to budding entrepreneurs.</li>
          <li>To bridge the gap between academic knowledge and industrial application.</li>
          <li>To support students in developing scalable and sustainable business models.</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h4 class="section-subtitle">Key Facilities</h4>
        <ul class="inner-lead">
          <li><strong>Co-Working Spaces:</strong> Open environments designed for collaborative brainstorming and project development.</li>
          <li><strong>Prototyping Labs:</strong> Specialized tools and equipment for building and testing initial product versions.</li>
          <li><strong>Expert Mentorship:</strong> Direct access to experienced entrepreneurs and industry veterans.</li>
          <li><strong>Networking Events:</strong> Regular opportunities to connect with potential investors and business partners.</li>
          <li><strong>Skill Workshops:</strong> Training in business planning, financial management, and legal requirements.</li>
        </ul>
      </div>
    </div>

    <!-- Optional: Add image gallery here as per assets/img/incubation/ -->
  </div>
</div>
